import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-knowledge-unit.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessKnowledgeUnit';

class AgentBookingMailInprocessKnowledgeUnitCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessKnowledgeUnit implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessKnowledgeUnitCtrl];
}

export default MODULE_NAME;
